/* ========================================================
    RC BESPOKE CART PAGE — DIAMOND & SETTING VALIDATION
======================================================== */

/* ========= GET DIAMOND INFO FROM CART FOR PRICE CHECK ========= */
function rcGetDiamondProductFromCart(cartItems) {
  const diamond = cartItems.find(item => item.product_type === 'Diamond');
  if (!diamond) return null;

  return {
    diamond_productId:   String(diamond.product_id),
    diamond_variantId:   String(diamond.variant_id),
    diamond_retailPrice: '$' + (diamond.price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    diamondTitle:        diamond.title
  };
}

/* ========= CHECK DIAMOND + SETTING BOTH PRESENT ========= */
function rcCheckBespokeDiamondConditions(cartItems) {
  const hasDiamond  = cartItems.some(i => i.product_type === 'Diamond');
  const hasSetting  = cartItems.some(i =>
    i.product_type === 'Vow Engagement Rings' ||
    i.product_type === 'Engagement Rings' ||
    i.product_type === 'Engagement Ring'
  );

  if (hasDiamond && !hasSetting) {
    $('#rc-generic-popup-close').remove();
    $('#rc-generic-popup').find('.rc-popup-heading').remove();
    $('#rc-generic-popup').find('.rc-popup-subtext').text('This diamond has no setting, please select a setting.');
    $('#rc-generic-popup').find('.rc-popup-cta').attr('id', 'rc-cart-validation-cta').text('GO SEE OTHER DIAMONDS');
    $('#rc-generic-popup').addClass('open');

    $(document).one('click', '#rc-cart-validation-cta', async function () {
      $(this).text('Please wait...').prop('disabled', true);
      await rcRemoveBespokeItemsAndRedirect(cartItems);
    });
    return false;
  }

  if (hasSetting && !hasDiamond) {
    $('#rc-generic-popup-close').remove();
    $('#rc-generic-popup').find('.rc-popup-heading').remove();
    $('#rc-generic-popup').find('.rc-popup-subtext').text('This diamond is not available, please select a different diamond.');
    $('#rc-generic-popup').find('.rc-popup-cta').attr('id', 'rc-cart-validation-cta').text('GO SEE OTHER DIAMONDS');
    $('#rc-generic-popup').addClass('open');

    $(document).one('click', '#rc-cart-validation-cta', async function () {
      $(this).text('Please wait...').prop('disabled', true);
      await rcRemoveBespokeItemsAndRedirect(cartItems);
    });
    return false;
  }

  return true;
}

/* ========= CHECK DIAMOND PRICE ========= */
async function rcCheckDiamondPriceOnCheckout(cartItems) {
  const diamondInfo = rcGetDiamondProductFromCart(cartItems);
  if (!diamondInfo) return true; // No diamond — skip check, allow checkout

  try {
    const res = await fetch(`${portalApiUrl}/verify_diamond_price`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(diamondInfo)
    }).then(r => r.json());

    if (res?.action === 'remove') {
      $('#rc-generic-popup').find('.rc-popup-heading').text('The price of your diamond has changed.');
      $('#rc-generic-popup-close').remove();
      $('#rc-generic-popup').find('.rc-popup-subtext').text('Please click continue to see the updated price.');
      $('#rc-generic-popup').find('.rc-popup-cta').attr('id', 'rc-cart-price-changed-cta').text('CONTINUE');
      $('#rc-generic-popup').addClass('open');

      $(document).one('click', '#rc-cart-price-changed-cta', async function () {
        $(this).text('Please wait...').prop('disabled', true);
        await rcRemoveBespokeItemsAndRedirect(cartItems);
      });

      return false; // Block checkout
    }

    return true; // Price OK — allow checkout
  } catch (err) {
    console.error('RC: verify_diamond_price error:', err);
    return true; // On error, allow checkout
  }
}

/* ========= REMOVE BESPOKE ITEMS AND REDIRECT TO PDP ========= */
async function rcRemoveBespokeItemsAndRedirect(cartItems) {
  const updates = {};
  let settingItem = null;

  cartItems.forEach(item => {
    if (
      item.product_type === 'Diamond' ||
      item.product_type === 'Vow Engagement Rings' ||
      item.product_type === 'Engagement Rings' ||
      item.product_type === 'Engagement Ring'
    ) {
      updates[item.key] = 0;
      if (
        item.product_type === 'Vow Engagement Rings' ||
        item.product_type === 'Engagement Rings' ||
        item.product_type === 'Engagement Ring'
      ) {
        settingItem = item;
      }
    }
  });

  clearBespokeSelectedData();

  if (Object.keys(updates).length > 0) {
    await fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ updates })
    }).catch(err => console.error('RC: cart update error:', err));
  }

  if (settingItem?.handle) {
    window.location.href = `/products/${settingItem.handle}`;
  } else {
    window.location.href = '/collections/ring-builder';
  }
}

/* ========= CHECKOUT BUTTON: MAIN GATE ========= */
$(document).on('click', '.rc-cart-checkout-button', async function (e) {
  const cart = await fetch('/cart.js').then(r => r.json());
  const cartItems = cart.items || [];

  const hasBespoke = cartItems.some(i =>
    i.product_type === 'Diamond' ||
    i.product_type === 'Vow Engagement Rings' ||
    i.product_type === 'Engagement Rings' ||
    i.product_type === 'Engagement Ring'
  );

  // No bespoke items — do nothing, let the button's default action run
  if (!hasBespoke) return;
  e.preventDefault();

  try {
    const conditionsOk = rcCheckBespokeDiamondConditions(cartItems);
    if (!conditionsOk) return;

    const priceOk = await rcCheckDiamondPriceOnCheckout(cartItems);
    if (!priceOk) return;

    window.location.href = '/checkout';

  } catch (err) {
    console.error('RC: checkout validation error:', err);
    window.location.href = '/checkout';
  }
});

/* ========= AUTO-RUN ON CART PAGE LOAD ========= */
(async function rcCartPageInit() {
  if (!window.location.pathname.includes('/cart')) return;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const cartItems = cart.items || [];

    const hasBespoke = cartItems.some(i =>
      i.product_type === 'Diamond' ||
      i.product_type === 'Vow Engagement Rings' ||
      i.product_type === 'Engagement Rings' ||
      i.product_type === 'Engagement Ring'
    );

    if (!hasBespoke) return;

    // Step 1: Check diamond + setting conditions
    const conditionsOk = rcCheckBespokeDiamondConditions(cartItems);
    if (!conditionsOk) return;

    // Step 2: Check diamond price on load as well
    await rcCheckDiamondPriceOnCheckout(cartItems);

  } catch (err) {
    console.error('RC: cart page init error:', err);
  }
})();